import { render, staticRenderFns } from "./StationResource.vue?vue&type=template&id=49cf1a64"
import script from "./StationResource.vue?vue&type=script&lang=js"
export * from "./StationResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports